import React from 'react';
import Icon from '@mdi/react';
import { mdiCircleSlice1 } from '@mdi/js';

import './Loader.css';

const Loader = ({ color = 'white', raw, size = 5, className = ''}) => {
    if (raw)
        return <Icon size={ size } path={ mdiCircleSlice1 } color={ color } spin={1} />;

    return (
        <div className={`Loader ${className}`}>
            <div className="d-flex justify-center">
                <div className="align-self-center spinner-wrapper">
                    <Icon size={ size } path={ mdiCircleSlice1 } color={ color } spin={1} />
                </div>
            </div>
        </div>
    );
}

export default Loader;
